import React, { Suspense, lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import './App.css';
import './global/css/globalStyle.css';

import Loading from './components/Loading';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AlertMessage from './components/AlertMessage';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { initGA } from './components/Tracking';
import { gtag } from './config.js';

import FantasyScoresImg from './global/img/carousel/fantasyscores.jpg';
import PowerImg from './global/img/carousel/powerofinsideinjuries.jpg';
import ImpactImg from './global/img/carousel/impactofinjuries.jpg';
import DoctorsEdgeImg from './global/img/carousel/doctorsedge.png';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import Articles from './components/Articles';
import NFLMatchup from './components/Matchup/NFLMatchup';
import NFLTeam from './components/Team/NFLTeam';
import NBAMatchup from './components/Matchup/NBAMatchup';
import NBATeam from './components/Team/NBATeam';
import Player from './components/Player';
import CricketPlayer from './components/Player/CricketPlayer';
import About from './components/About';
import Whitepaper from './components/Whitepaper';
import Confirmation from './components/Confirmation';
import Cancel from './components/Confirmation/cancel';
import Updates from './components/Updates';
import SoccerMatchup from './components/Matchup/SoccerMatchup';
import SoccerTeam from './components/Team/SoccerTeam';
import SoccerUpdates from './components/Updates/soccer';
import CricketMatchup from './components/Matchup/CricketMatchup';
import CricketTeamDetails from './components/Team/CricketTeamDetails';
import UpcomingGames from './components/Dashboard/upcomingGames';
import ArticleDetail from './components/ArticleDetail/index.jsx';
import ArticleList from './components/ArticleList/index.jsx';
import EmailVerification from './components/EmailVerification/index.jsx';

const Admin = lazy(() => import('./components/Admin'));
const AdminArticles = lazy(() => import('./components/AdminArticles'));
const AdminEmailMarketing = lazy(() => import('./components/AdminEmailMarketing'));
const CreateEmailCampaign = lazy(() => import('./components/CreateEmailCampaign'));
const TeamHealthScore = lazy(() => import('./components/TeamHealthScore'));
const AdminCreateArticle = lazy(() => import('./components/AdminArticles/CreateArticle'));
const Profile = lazy(() => import('./components/Profile/index.jsx'));

const LazyRoute = ({ children }) => (
	<Suspense fallback={<Loading />}>
		{children}
	</Suspense>
);


function App(props) {
	const { user, userActions, schedules, dispatch, subscriptionActions, collectCC } = props;

	useEffect(() => {
		initGA(gtag);

		if (!user?.login) {
			dispatch({ type: 'MAKE_SAMPLE_TOKEN' });
		}

		dispatch({ type: 'GET_OPTIONS' });

		if (window.location.href.includes('logout')) {
			dispatch({ type: 'LOGOUT' });
		}

		// if (user.login) {
		// 	dispatch({ type: 'REFRESH_USER' });
		// }

		dispatch({ type: 'CHECK_LOGIN' });
		dispatch({ type: 'GET_PRICES' });

	}, [user.login]);

	if (
		userActions.isLoading ||
		schedules.isLoading ||
		subscriptionActions?.isLoading ||
		collectCC?.isLoading
	) {
		return <Loading />;
	}

	const carouselArticleImages = {
		FantasyScoresImg,
		PowerImg,
		ImpactImg,
		DoctorsEdgeImg
	};

	const assignCurrentSport = () => {
		const sport = window.location.pathname.split('/')[1]?.toUpperCase();
		const searchParams = new URLSearchParams(window.location.search);
		const league = searchParams.get('league')?.toUpperCase();

		if (sport?.toUpperCase() === 'SOCCER') {
			dispatch(actions.change('user.sportsID', 3));
			dispatch(actions.change('user.sportsName', 'soccer'));

			if (league === 'EPL') {
				dispatch(actions.change('user.league', 'EPL'));
			} else if (league === 'ESP') {
				dispatch(actions.change('user.league', 'ESP'));
			} else {
				dispatch(actions.change('user.league', ''));
			}

		} else if (sport?.toUpperCase() === 'NBA') {

			dispatch(actions.change('user.sportsID', 2));
			dispatch(actions.change('user.sportsName', 'nba'));
			dispatch(actions.change('user.league', ''));

		} else if (sport?.toUpperCase() === 'CRICKET') {

			dispatch(actions.change('user.sportsID', 4));
			dispatch(actions.change('user.sportsName', 'cricket'));
			dispatch(actions.change('user.league', league || 'IPL'));

		} else {

			dispatch(actions.change('user.sportsID', 1));
			dispatch(actions.change('user.sportsName', 'nfl'));
			dispatch(actions.change('user.league', ''));

		}
	};

	const page = window.location.pathname.split('/')[1]?.toUpperCase();

	let hideNavbarFooter = false;

	if (page?.toUpperCase() === 'LOGIN' || page?.toUpperCase() === 'RESETPASSWORD') {
		hideNavbarFooter = true;
	}

	return (
		<div className='App'>

			<AlertMessage />

			{!hideNavbarFooter ?
				<Navbar subscriberPage={page?.toUpperCase() === 'SUBSCRIBE'} />
				: null}

			<Router>
				<Routes>

					<Route exact path='/' element={<Dashboard carouselArticleImages={carouselArticleImages} />} />

					<Route exact path='/signup' element={<Signup />} />
					<Route exact path='/login' element={<Signup />} />

					<Route exact path='/updates' element={<Updates />} />

					{user?.admin && <Route exact path='/admin' element={<LazyRoute><Admin /></LazyRoute>} />}

					{user?.admin && <Route exact path='/admin-panel/articles' element={<LazyRoute><AdminArticles /></LazyRoute>} />}
					{user?.admin && <Route exact path='/admin-panel/articles/create' element={<LazyRoute><AdminCreateArticle /></LazyRoute>} />}
					{user?.admin && <Route exact path='/admin-panel/articles/edit/:id' element={<LazyRoute><AdminCreateArticle /></LazyRoute>} />}

					{user?.admin && <Route exact path='/admin-panel/email-marketing' element={<LazyRoute><AdminEmailMarketing /></LazyRoute>} />}
					{user?.admin && <Route exact path='/admin-panel/email-marketing/create' element={<LazyRoute><CreateEmailCampaign /></LazyRoute>} />}
					{user?.admin && <Route exact path='/admin-panel/email-marketing/edit/:id' element={<LazyRoute><CreateEmailCampaign /></LazyRoute>} />}

					{user?.admin && <Route exact path='/admin/team_health_score' element={<LazyRoute><TeamHealthScore /></LazyRoute>} />}

					<Route exact path='/confirmation' element={<Confirmation />} />
					<Route exact path='/cancel' element={<Cancel />} />

					<Route exact path='/whitepaper' element={<Whitepaper />} />

					<Route exact path='/articles/:articlename' element={<Articles carouselArticleImages={carouselArticleImages} />} />

					<Route exact path='/about' element={<About />} />

					<Route exact path='/:sport?/dashboard/:urlparam' element={<Dashboard carouselArticleImages={carouselArticleImages} />} />
					<Route exact path='/:sport?/dashboard' element={<Dashboard carouselArticleImages={carouselArticleImages} />} />

					<Route exact path='/nba' element={<UpcomingGames assignCurrentSport={assignCurrentSport} page={page} />} />
					<Route exact path='/cricket' element={<UpcomingGames assignCurrentSport={assignCurrentSport} page={page} />} />

					<Route exact path='/:sport?/upcominggames' element={<UpcomingGames assignCurrentSport={assignCurrentSport} />} />

					<Route exact path='/nfl/matchup/:id' element={<NFLMatchup assignCurrentSport={assignCurrentSport} />} />
					<Route exact path='/nfl/team/:id' element={<NFLTeam assignCurrentSport={assignCurrentSport} />} />

					<Route exact path='/nba/matchup/:id' element={<NBAMatchup assignCurrentSport={assignCurrentSport} />} />
					<Route exact path='/nba/team/:id' element={<NBATeam assignCurrentSport={assignCurrentSport} />} />

					<Route exact path='/cricket/matchup/:id' element={<CricketMatchup assignCurrentSport={assignCurrentSport} />} />
					<Route exact path='/cricket/team/:id' element={<CricketTeamDetails />} />
					<Route exact path='/cricket/ipl/player/:id' element={<CricketPlayer />} />

					<Route exact path='/soccer/matchup/:id' element={<SoccerMatchup assignCurrentSport={assignCurrentSport} />} />
					<Route exact path='/soccer/team/:id' element={<SoccerTeam assignCurrentSport={assignCurrentSport} />} />
					<Route exact path='/soccer/updates' element={<SoccerUpdates />} />

					<Route exact path='/:sport?/player/:id' element={<Player />} />

					<Route exact path='/resetpassword' element={<Signup />} />

					<Route exact path='/verify-email' element={<EmailVerification />} />
					<Route exact path='/profile' element={<LazyRoute><Profile /></LazyRoute>} />

					<Route exact path='/articles' element={<ArticleList />} />
					<Route exact path='/article/:articlename' element={<ArticleDetail />} />

				</Routes>
			</Router>

			{!hideNavbarFooter ? <Footer /> : null}

		</div>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	freeAccess: state.freeAccess,
	user: state.user,
	userActions: state.userActions,
	schedules: state.schedules,
	prices: state.prices,
	subscriptionActions: state.subscriptionActions,
	sources: state.sources,
	collectCC: state.collectCC,
	adminTeamHeathScoreNFL: state.adminTeamHealthScoreNFL
});

export default connect(mapStateToProps)(App);
